<template>

  <v-layout class="docuform-list-item"
            justify-space-between>

    <div class="docuform-info">
      <div class="docuform-info__title"
           data-qa="docuform-title">
        {{docuform.title}}
      </div>
      <div v-if="isMultiStaff && docuform.staff_name"
           class="docuform-info__details">
        <VcIcon>icon-Male</VcIcon>
        <span class="docuform-staff">{{docuform.staff_name}}</span>
      </div>
    </div>

    <DisplayName :matter="docuform.matter" :contact="docuform.contact"/>

    <div class="docuform-status">
      <div class="docuform-status__title">
        <VcIcon :color="statusInfo.color">{{statusInfo.icon}}</VcIcon>
        <span class="docuform-status__title__text" data-qa="docuform-status" :style="{color: statusInfo.color}">{{$t(statusInfo.label)}}</span>
      </div>
      <div class="docuform-status__date">{{docuform.updated_at | time_today_or_date}}</div>
    </div>
  </v-layout>

</template>

<script>
import {DisplayName} from "@/modules/common/components";
import {statuses} from "@/modules/docuform/constants";
import getStatus from '@/modules/docuform/services/statusService';
import {mapGetters} from "vuex";

export default {
  name: "DocuformListItemDesktop",
  components: {DisplayName},
  props: {
    docuform: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statuses: statuses
    }
  },
  computed: {
    ...mapGetters("accountModule", ["isMultiStaff"]),
    statusInfo() {
      return getStatus(this.docuform);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuform-list-item {
  width: 100%;

  .docuform-info {
    width: 50%;
    @include ellipsis;

    &__title {
      font-size: 15px;
      font-weight: 500;
    }

    &__details {
      font-size: 12px;

      .v-icon {
        color: $black-color-2;
        font-size: 17px;
        margin-inline-end: 5px;
      }

      .docuform-staff {
        position: relative;
        top: 1px;
      }
    }
  }

  .display-name {
    width: 25%;
    @include ellipsis;
  }

  .docuform-status {
    width: 15%;
    @include ellipsis;

    &__title {
      @include ellipsis;

      .v-icon {
        font-size: 16px;
        margin-inline-end: 6px;
      }

      &__text {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    &__date {
      font-size: 13px;
      color: $grey-color-6;
    }
  }
}
</style>
